(() => {
  const root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';

  /* Apparition des sections (équivalent animate--shown de la source) */
  const reveal = (el) => { el.classList.remove('animate--hidden'); el.classList.add('animate--shown'); };
  const io = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => entries.forEach((e) => { if (e.isIntersecting) { reveal(e.target); io.unobserve(e.target); } }), { rootMargin: '0px 0px -10% 0px' })
    : null;
  document.querySelectorAll('.animate-section').forEach((el) => (io ? io.observe(el) : reveal(el)));
  document.querySelectorAll('.animate-item--child').forEach((el, i) => { if (!el.style.getPropertyValue('--index')) el.style.setProperty('--index', i % 6); });

  /* En-tête : menu mobile */
  document.querySelectorAll('.menu-drawer__close-menu-btn').forEach((b) => b.addEventListener('click', () => b.closest('details').removeAttribute('open')));
  document.querySelectorAll('.menu-drawer__close-button').forEach((b) => b.addEventListener('click', () => b.closest('details').removeAttribute('open')));
  const drawerDetails = document.getElementById('Details-menu-drawer-container');
  if (drawerDetails) {
    drawerDetails.addEventListener('toggle', () => {
      document.body.classList.toggle('overflow-hidden-tablet', drawerDetails.open);
      drawerDetails.classList.toggle('menu-opening', drawerDetails.open);
    });
  }
  document.querySelectorAll('header-menu details').forEach((d) => {
    document.addEventListener('click', (e) => { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });

  /* En-tête collant qui réapparaît en remontant */
  const sticky = document.querySelector('.section-header');
  if (sticky) {
    let last = 0;
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      if (y > last && y > sticky.offsetHeight + 100) sticky.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      else if (y < last) { sticky.classList.remove('shopify-section-header-hidden'); sticky.classList.toggle('shopify-section-header-sticky', y > 0); }
      last = y;
    }, { passive: true });
  }

  /* Panier (tiroir) */
  const drawer = () => document.getElementById('mc-cart-drawer');
  const openCart = () => { const d = drawer(); if (!d) return; d.classList.add('animate'); setTimeout(() => d.classList.add('active'), 20); document.body.classList.add('overflow-hidden'); };
  const closeCart = () => { const d = drawer(); if (!d) return; d.classList.remove('active'); document.body.classList.remove('overflow-hidden'); };
  const renderCart = async (sectionsHtml) => {
    let html = sectionsHtml && sectionsHtml['mc-cart-drawer'];
    if (!html) { const r = await fetch(root + '?sections=mc-cart-drawer'); html = (await r.json())['mc-cart-drawer']; }
    const tmp = new DOMParser().parseFromString(html, 'text/html');
    const fresh = tmp.getElementById('mc-cart-drawer');
    const cur = drawer();
    if (fresh && cur) {
      const wasActive = cur.classList.contains('active');
      cur.replaceWith(fresh);
      if (wasActive) fresh.classList.add('animate', 'active');
    }
    const fix = (drawer() && drawer().dataset.mcFix) || '';
    if (fix && !renderCart.fixing) {
      renderCart.fixing = true;
      const ops = fix.split(',').filter(Boolean).map((x) => x.split(':').map(Number)).sort((a, b) => b[0] - a[0]);
      for (const [line, qty] of ops) await fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line, quantity: qty }) });
      renderCart.fixing = false;
      return renderCart();
    }
    const cart = await (await fetch(root + 'cart.js')).json();
    document.querySelectorAll('[data-mc-cart-count]').forEach((b) => { b.hidden = cart.item_count === 0; b.querySelector('span').textContent = cart.item_count; });
  };
  window.mcAddToCart = async (items) => {
    const r = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items, sections: 'mc-cart-drawer' }) });
    const data = await r.json();
    if (!r.ok) { alert(data.description || data.message || 'Fehler'); return false; }
    await renderCart(data.sections);
    openCart();
    return true;
  };
  const changeLine = async (line, quantity) => {
    const r = await fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line, quantity, sections: 'mc-cart-drawer' }) });
    const data = await r.json();
    await renderCart(data.sections);
  };
  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-mc-cart-open]');
    if (open && drawer()) { e.preventDefault(); openCart(); return; }
    if (e.target.closest('[data-mc-cart-close]')) { e.preventDefault(); closeCart(); return; }
    const line = e.target.closest('[data-mc-line]');
    if (line) { e.preventDefault(); line.disabled = true; changeLine(Number(line.dataset.mcLine), Number(line.dataset.mcQty)); return; }
    const add = e.target.closest('[data-mc-add]');
    if (add) { e.preventDefault(); add.disabled = true; window.mcAddToCart([{ id: Number(add.dataset.mcAdd), quantity: 1 }]); }
  });
  document.addEventListener('keyup', (e) => { if (e.key === 'Escape') closeCart(); });

  /* Carrousels Swiper */
  const initSwipers = () => {
    if (!window.Swiper) return;
    document.querySelectorAll('[data-mc-swiper]:not(.swiper-initialized)').forEach((el) => {
      const wrap = el.closest('section, .shopify-section') || document;
      const opts = {
        slidesPerView: Number(el.dataset.viewMobile || 1),
        spaceBetween: Number(el.dataset.gapMobile || 16),
        loop: el.dataset.loop === 'true',
        breakpoints: { 750: { slidesPerView: Number(el.dataset.viewTablet || el.dataset.view || 1) }, 1024: { slidesPerView: Number(el.dataset.view || 3), spaceBetween: Number(el.dataset.gap || 12) } }
      };
      if (el.dataset.prev) opts.navigation = { prevEl: wrap.querySelector(el.dataset.prev), nextEl: wrap.querySelector(el.dataset.next) };
      if (el.dataset.pagination) opts.pagination = { el: wrap.querySelector(el.dataset.pagination), clickable: true };
      new Swiper(el, opts);
    });
  };
  window.addEventListener('load', initSwipers);

  /* Vidéos à lecture / pause (sections vidéo clients) */
  document.querySelectorAll('.slidev8').forEach((slide) => {
    const v = slide.querySelector('video'); const play = slide.querySelector('.play-buttonv8'); const pause = slide.querySelector('.pause-buttonv8');
    if (!v) return;
    const sync = () => { if (v.paused) { play.style.display = 'flex'; pause.style.display = 'none'; } else { play.style.display = 'none'; pause.style.display = 'flex'; } };
    slide.addEventListener('click', () => { if (v.paused) { v.muted = true; v.play(); } else v.pause(); sync(); });
    v.addEventListener('play', sync); v.addEventListener('pause', sync); sync();
  });

  if (drawer() && drawer().dataset.mcFix) renderCart();
  document.dispatchEvent(new CustomEvent('mc:ready'));
})();
